import React, { Component } from 'react';
import store from '../../../store/store';
import { TransactionTableStyledMemory } from '../../BaseComponent/memory';
import AddProductContext from './AddProductContext';
import { addOffer } from '../../Offers/reducer/offerSlice';

/**
 * @param startPage always should be 0 when it comes to 1st page since react-pagination require 1st page to be index = 0
 */

class AddProductProvider extends TransactionTableStyledMemory {
  primaryMemory = {};

  state = {
    // jwtToken: '',
    // clientToken: '',
    // userData: '',
    primaryMemory: this.primaryMemory,
    active: "",
    name: "",
    type: "",
    expireDate: "",
    discountPercentage: 0,
  };

  prevState = [];

  setJwtToken = (jwtToken) => {
    if (jwtToken !== this.state.jwtToken) {
      this.setState({
        ...this.state,
        jwtToken,
      });
    }
  };

  setUserToken = (clientToken) => {
    if (clientToken !== this.state.clientToken) {
      this.setState({
        ...this.state,
        clientToken,
      });
    }
  };

  addNewOffer = ({ ...options }) => {
    const convState = {
      // ...this.state,
      active: true,
      name: options.offerName,
      type: options.type,
      expireDate: options.expireDate,
      discountPercentage: options.discountPercentage,
    };
    

    console.log('convState', convState)

    this.makeDispatch(convState);
  };

  makeDispatch = async ({ ...options }) => {
    return store.dispatch(addOffer(options));
  };

  render() {
    const contextValue = {
      jwtToken: this.state.jwtToken,
      setJwtToken: this.setJwtToken,
      addNewOffer: this.addNewOffer,
      setUserToken: this.setUserToken,
      clientToken: this.state.clientToken,
      primaryMemory: this.state.primaryMemory,
    };

    return <AddProductContext.Provider value={contextValue}>{this.props.children}</AddProductContext.Provider>;
  }
}

export default AddProductProvider;
